<div class="container-fluid bg-green-gradient text-white">
    <div class="container-narrow py-5 d-flex align-items-center">
        <div class="me-5"><img src="/assets/img/svg/cosa_sono_icon_56x34.svg" width="56" height="34" alt="! ? ?"></div>
        <div>
            <h2 class="h6">Che cosa sono i Sai, i Cas e la prima accoglienza.</h2>
            Si tratta delle tre principali categorie di centri di accoglienza presenti oggi in Italia. Nei centri di prima accoglienza le persone vengono identificate e indirizzate verso i passaggi successivi. Il Sai è il sistema ordinario di accoglienza. I Cas invece dovrebbero essere attivati solo in via straordinaria, a causa della mancanza di posti negli altri centri.
        </div>
    </div>
</div>
